import { useEffect } from 'react';
import { ArrowRight, FileSpreadsheet, LayoutDashboard } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Badge } from '@/components/ui';
import { DashboardGrid } from '@/components/object-views/DashboardGrid';
import { VersionComparison } from '@/components/object-views/VersionComparison';
import { OBJECT_VIEWS_HOME, SHORT_DEFINITIONS, VERSION_AFTER, VERSION_BEFORE } from '../object-views/model';
import { Code, Section } from './Section';
export function ObjectViewsSection() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== '#object-views') return;
    let active = true;
    const align = () => {
      if (active)
        document.getElementById('object-views')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    const frame = requestAnimationFrame(align);
    void document.fonts.ready.then(align);
    return () => {
      active = false;
      cancelAnimationFrame(frame);
    };
  }, [hash]);
  return (
    <Section
      id="object-views"
      title="Обзоры, обмен данными и версии"
      lead="Виджеты, проверенный импорт CSV и сравнение свойств — общие средства для любого сервиса."
    >
      <div className="grid items-start gap-6 lg:grid-cols-3">
        <div className="min-w-0 space-y-4 rounded-lg border border-line bg-card p-4">
          <h3 className="flex items-center gap-2 type-heading">
            <LayoutDashboard className="size-5 text-fg-muted" />
            Настраиваемый обзор
          </h3>
          <DashboardGrid
            label="Пример виджета"
            widgets={[
              {
                id: 'total',
                title: 'Проверки за неделю',
                content: (
                  <div className="flex items-end justify-between gap-3">
                    <span className="type-title">86</span>
                    <Badge>+14 за неделю</Badge>
                  </div>
                ),
              },
            ]}
            layout={[{ widgetId: 'total', span: 'wide' }]}
            readOnly
          />
          <Code>DashboardGrid · порядок / ширина / состав · equalRowHeight</Code>
        </div>
        <div className="min-w-0 space-y-4 rounded-lg border border-line bg-card p-4">
          <h3 className="flex items-center gap-2 type-heading">
            <FileSpreadsheet className="size-5 text-fg-muted" />
            Импорт и экспорт
          </h3>
          <ol className="space-y-3 text-sm">
            <li className="rounded-md border border-line bg-muted p-3">1. CSV в UTF-8</li>
            <li className="rounded-md border border-line bg-muted p-3">2. Колонки → поля</li>
            <li className="rounded-md border border-line bg-muted p-3">3. Проверка и предпросмотр</li>
          </ol>
          <p className="text-xs text-fg-muted">
            Весь пакет проверяется до записи. Выгрузка защищает текст от формул.
          </p>
          <Code>CsvImporter · CsvExport</Code>
        </div>
        <div className="min-w-0 space-y-4 rounded-lg border border-line bg-card p-4">
          <h3 className="type-heading">Было → стало</h3>
          <VersionComparison
            label="Пример сравнения"
            definitions={SHORT_DEFINITIONS}
            before={VERSION_BEFORE}
            after={VERSION_AFTER}
          />
          <Code>VersionComparison · типизированные значения</Code>
        </div>
      </div>
      <Link
        to={OBJECT_VIEWS_HOME}
        className="inline-flex h-9 items-center gap-2 self-start rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        Открыть образец
        <ArrowRight className="size-4" />
      </Link>
    </Section>
  );
}
